module.exports = __webpack_public_path__ + "img/48.148761b3.png";